import { render, staticRenderFns } from "./EditConsumabile.vue?vue&type=template&id=194ac440&scoped=true"
import script from "./EditConsumabile.vue?vue&type=script&lang=js"
export * from "./EditConsumabile.vue?vue&type=script&lang=js"
import style0 from "./EditConsumabile.vue?vue&type=style&index=0&id=194ac440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ac440",
  null
  
)

export default component.exports